import { Team, TriviaRound } from '@core/models';
import moment from 'moment';
import { EventColumnTypes } from '@core/enums';

export class GameHelper {
  static isLessThanTwoHours = (datetime) =>
    moment(datetime).diff(moment(), 'minutes') <= 120;

  static sortGameRoundQuestions(
    data: {
      trivia_round: TriviaRound;
      round_questions_count: number;
      round_order: number;
    }[],
  ): {
    trivia_round: TriviaRound;
    round_questions_count: number;
    round_order: number;
  }[] {
    if (!Array.isArray(data)) return data;
    for (const round of data) {
      round.trivia_round.trivia_round_questions.sort(
        (a, b) => a.question_order - b.question_order,
      );
    }
    return data;
  }

  static setActiveAnswers(
    data: {
      trivia_round: TriviaRound;
      round_questions_count: number;
      round_order: number;
    }[],
  ): {
    trivia_round: TriviaRound;
    round_questions_count: number;
    round_order: number;
  }[] {
    if (!Array.isArray(data)) return data;
    for (const round of data) {
      for (const questionData of round.trivia_round.trivia_round_questions) {
        const rightAnswers: string[] = [];
        for (const answer in questionData.question.question_json.answers) {
          if (questionData.question.question_json.answers[answer]) {
            rightAnswers.push(answer);
          }
        }
        questionData.question.right_answers = rightAnswers;
      }
    }
    return data;
  }

  static selectAppQuestionIndex(
    gameFlow: number,
    activeQuestionIndex: number,
    questionsCount: number,
  ): number {
    return gameFlow === 6 &&
      activeQuestionIndex > 0 &&
      questionsCount - 1 !== activeQuestionIndex
      ? activeQuestionIndex + 1
      : activeQuestionIndex;
  }

  static checkStateChanges(prev, curr): boolean {
    return (
      prev[1] === curr[1] &&
      prev[0].activeQuestionIndex === curr[0].activeQuestionIndex &&
      prev[0].activeRoundIndex === curr[0].activeRoundIndex
    );
  }

  static sortByOrder = (a: Team, b: Team) => {
    if (a.order < b.order) {
      return -1;
    } else if (a.order > b.order) {
      return 1;
    } else {
      return 0;
    }
  };

  static setGameStatusByDate(startDatetime): number {
    let status = EventColumnTypes.completed;
    if (moment().diff(moment(startDatetime), 'hours') <= 24) {
      status = EventColumnTypes.todays;
    }
    if (moment().isBefore(startDatetime, 'day')) {
      status = EventColumnTypes.scheduled;
    }

    return status;
  }

  public static uniformApostrophe<T>(answers: T): T {
    if (!answers) return;
    const updatedAnswers = {};
    const replaceChar = '’';
    const regexp = new RegExp(replaceChar, 'g');
    if (Array.isArray(answers)) {
      answers.map((e) => {
        if (typeof e === 'string') {
          e = e.replace(regexp, `'`) as T;
        }
        return e;
      });
      return answers;
    } else if (typeof answers === 'object') {
      for (const key in answers) {
        const newKey = key.replace(regexp, `'`);
        updatedAnswers[newKey] = answers[key];
      }
      return updatedAnswers as T;
    } else if (typeof answers === 'string') {
      answers = answers.replace(regexp, `'`) as T;
      return answers;
    }
  }
}
